import React from 'react';
import { Body, MaterialIcon, Stack } from '@qred/components-library';
import useTranslate from '~/hooks/useTranslate';

const NoQCode = () => {
  const t = useTranslate();
  return (
    <Stack
      data-testid="update-application-noqcode"
      spacing="xxl"
      align="center"
      justify="center"
      p="1.5em"
    >
      <MaterialIcon src="link_off" filled size="48" color="Icon/Default" />
      <Body size="lg" data-record>
        {t('UpdateApplication.NoQCode')}
      </Body>
    </Stack>
  );
};

export default NoQCode;
